import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FiberNewIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fiber_new"}/>
}
